export async function delay(timeoutInMs = 3000): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, timeoutInMs));
}
